<template>
    <div class="router-tabs">
        <div 
            v-for="(item,index) in tabList" 
            :key="index"
            :class="[tabIndex == item.index ? 'tabs-active' : '','tabs-item']"
            @click="changeTab(item)">
            {{item.name}}
        </div>
        <div class="router-tab-right">
            <slot  name='router-tab-right'></slot>
        </div>
    </div>
</template>

<script>

export default {
    name:'router-tabs',
    props:{
        tabList:{
            type:Array,
            default:()=>{return []}
        },
        tabIndex:{
            type:Number,
            default:0
        }
    },
    methods:{
        changeTab: function (tab) {
            this.$emit('changeTab', tab)
        }
    }
}
</script>

<style lang="less" scoped>
.router-tabs{
    font-size: 0;
    border-bottom: 1px solid #E3E8EE;

    .tabs-item{
        display: inline-block;
        padding: 13px 0;
        margin-left: 24px;
        font-size: 14px;
        font-weight: bold;
        color: #464C5B;
        cursor: pointer;

        &:hover{
            color: #1f6cdd;
        }
    }
    .tabs-active{
        color: #1f6cdd;
        border-bottom: 2px solid #1f6cdd;
    }

    .router-tab-right{
        display: inline-block;
        height: 50px;
        line-height: 50px;
        vertical-align: middle;
        float: right;
        margin-right: 24px;
        font-size: 14px;
        color: #464C5B;
    }
}
</style>
